import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { background, border, flexbox, layout, space, typography, grid, textAlign as styledAlign } from 'styled-system';
import { color as paletteColor, gap, getPaletteColor } from '@magalu/stereo-ui-styles';
const typeReset = {
  a: css`
    text-decoration: none;
  `,
  button: css`
    font-size: inherit;
    font-family: inherit;
    border: 0;
    margin: 0;
    overflow: visible;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  `
}; // Using .attrs to define default props
// Docs: https://styled-components.com/docs/api#attrs

export const Link = styled.a.attrs(_ref => {
  let {
    color
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["color"]);

  return Object.assign({
    color: color || 'text.base',
    fontSize: 1
  }, otherProps);
})`
  cursor: pointer;

  ${({
  as
}) => typeReset[as]}
  ${({
  textAlign
}) => textAlign ? css`
          display: block;
        ` : css`
          ${{
  display: 'inline-flex'
}}
          ${flexbox}
          align-items: center;
        `}
  ${({
  underline
}) => underline && css`
      text-decoration: underline;
    `}
  ${({
  hover
}) => hover && css`
      &:hover {
        text-decoration: ${props => props != null && props.underlineOnHover ? 'underline' : !(props != null && props.underline) && 'none'};
        color: ${props => props.colorOnHover || getPaletteColor(props.color)(props) || props.color};
      }
    `}
  ${background}
  ${border}
  ${layout}
  ${paletteColor}
  ${space}
  ${styledAlign}
  ${typography}
  ${grid}
  ${gap}
`;